import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { Box, Button } from '@mui/joy';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import useEvent from '../../hooks/useEvent';
import { useUser } from '../../hooks/useUser';
import { downloadAttendeesList } from '../../redux/services/eventsService';

const ExportAttendeesButton = () => {
  const params = useParams();
  const eventQuery = useEvent(params.eventId as string);
  const userQuery = useUser();

  const jsonToExcel = (jsonData: Array<any>, filename: string) => {
    // Create a new workbook and sheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(jsonData);

    // Add the sheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Convert the workbook to an Excel file
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

    // Create a Blob object with the Excel file data
    const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });

    // Prompt the user to download the Excel file
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${filename}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const s2ab = (s: any) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  const isAdmin = useMemo(() => {
    return (
      userQuery.data?.role === 'ADMIN' || userQuery.data?.role === 'SUPER_ADMIN'
    );
  }, [userQuery]);

  if (!eventQuery.isSuccess || !userQuery.isSuccess) {
    return null;
  }

  if (!isAdmin) {
    return null;
  }

  return (
    <Box>
      <Button
        onClick={async () => {
          const attendees = await downloadAttendeesList(eventQuery.data._id);
          jsonToExcel(attendees, 'attendees');
        }}
        startDecorator={<FileDownloadRoundedIcon />}
        variant="soft"
      >
        Export
      </Button>
    </Box>
  );
};

export default ExportAttendeesButton;
